import { Config } from "@/app/config";
import { http } from "@/shared/ui";
import type { CsokFormFields, CsokResponse } from "./types";

interface RealEstateResultItem {
	id: number;
	name: string;
}

export async function requestRealEstateInfos(
	values: CsokFormFields,
): Promise<[RealEstateResultItem[], RealEstateResultItem[]]> {
	const { loanGoal } = values;
	const urlRealEstateSizes = Config.getApiUrl("/api/public/csok/real-estate-sizes", values);

	let urlRealEstateBuyings = Config.getApiUrl("/api/public/master-data/real-estate-buyings");
	switch (loanGoal) {
		case "EPITES":
			urlRealEstateBuyings = Config.getApiUrl("/api/public/master-data/real-estate-buildings");
			break;
		case "BOVITES":
			urlRealEstateBuyings = Config.getApiUrl("/api/public/master-data/real-estate-enlargements");
			break;
		default:
	}

	return Promise.all([http.getWithCache(urlRealEstateSizes), http.getWithCache(urlRealEstateBuyings)]);
}

export async function calculateCsok(values: CsokFormFields): Promise<CsokResponse> {
	return http.get(Config.getApiUrl("/api/public/csok/calculate", values));
}
